import flatten from 'lodash/flatten';
import sortBy from 'lodash/sortBy';
import { SegmentServiceModule } from 'services/tracking/segment/segment.service';

export const BulkImportServiceModule = angular
    .module('app.services.data.bulkImportService', [
        SegmentServiceModule
    ]).factory('bulkImportService', () => {
        return {
            getFormattedErrors,
            hasErrors,
            isImportSuccessful,
            isInvalidImageError,
            isTimeoutError,
            isUploadError
        };

        function getFormattedErrors(errorKeys, type = 'product') {
            if (!errorKeys || errorKeys.length === 0) {
                return;
            }
            return type === 'orderUpdate'
                ? formatErrorsForBulkUpdate(errorKeys)
                : errorKeys.map(formatErrorObj);
        }

        function formatErrorObj(errorObj) {
            const lines = getErrorLinesSnippet(errorObj.lines);
            let linesError = `On ${lines}`;
            let keyError = `for product with key '${errorObj.key}'`;
            let errorMsgs = `we found these errors: ${errorObj.errors.join(',')}`;
            return `${linesError}, ${keyError}, ${errorMsgs}`;
        }

        function getErrorLinesSnippet(errorLines) {
            let lines = `line ${errorLines[0]}`;
            if (errorLines.length > 1) {
                lines = `lines ${errorLines.join(', ')}`;
                if (isSequentialNumbers(errorLines)) {
                    lines = `lines ${errorLines[0]} - ${errorLines[errorLines.length - 1]}`;
                }
            }
            return lines;
        }

        function isSequentialNumbers(numbers) { // for display as 6-10 if sequential
            if (numbers.length < 2) return false;
            const span = (numbers[numbers.length - 1] - numbers[0]) + 1;
            return (span === numbers.length);
        }

        function formatErrorsForBulkUpdate(errorKeys) {
            const errorLineAndMessages = errorKeys
                .map(collectErrorsForBulkUpdate);
            return sortBy(flatten(errorLineAndMessages), 'line');
        }

        function collectErrorsForBulkUpdate(error) {
            return error.lines.map((line) => {
                return {
                    line,
                    message: error.errors.join(', ')
                };
            });
        }

        function hasErrors(response) {
            return !!(response.errorKeys && response.errorKeys.length > 0);
        }

        function isImportSuccessful(response) {
            const imported = (response.importedProducts || response.updatedOrders || response.itemsAdded);
            return imported > 0;
        }

        function isTimeoutError(error) {
            return !!(error && (error.status === 504 || error.status === -1));
        }

        function isUploadError(error) {
            return !!(error && (error.xhrStatus === 'error' && error.status === -1));
        }

        function isInvalidImageError(errorMessage) {
            let errorPrefix1 = 'Could not find an image at ';
            return !!(errorMessage &&
                errorMessage.length > errorPrefix1.length &&
                errorMessage.substring(0, errorPrefix1.length) === errorPrefix1);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/bulkImport.service.js